"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARS_FIRST_POLICY_4 = exports.MARS_FIRST_POLICY_3 = exports.MARS_FIRST_POLICY_2 = exports.MARS_FIRST_DEFAULT_POLICY = exports.MARS_FIRST_BONUS_2 = exports.MARS_FIRST_BONUS_1 = exports.MarsFirst = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Tags_1 = require("../../cards/Tags");
const Resources_1 = require("../../Resources");
const SpaceType_1 = require("../../SpaceType");
const Phase_1 = require("../../Phase");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const MarsCoalition_1 = require("../../cards/community/corporations/MarsCoalition");
const MarsFirstPolicy4Action_1 = require("../../cards/turmoil/standardActions/MarsFirstPolicy4Action");
class MarsFirst extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.MARS;
        this.description = 'Focused on Martian development and independence.';
        this.bonuses = [exports.MARS_FIRST_BONUS_1, exports.MARS_FIRST_BONUS_2];
        this.policies = [exports.MARS_FIRST_DEFAULT_POLICY, exports.MARS_FIRST_POLICY_2, exports.MARS_FIRST_POLICY_3, exports.MARS_FIRST_POLICY_4];
    }
}
exports.MarsFirst = MarsFirst;
class MarsFirstBonus01 {
    constructor() {
        this.id = 'mb01';
        this.description = 'Gain 1 M€ for each Building tag you have';
        this.isDefault = true;
    }
    getScore(player) {
        return player.getTagCount(Tags_1.Tags.BUILDING, 'raw');
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class MarsFirstBonus02 {
    constructor() {
        this.id = 'mb02';
        this.description = 'Gain 1 M€ for each tile you have ON MARS';
        this.isDefault = false;
    }
    getScore(player) {
        const boardSpaces = player.game.board.spaces;
        return boardSpaces.filter((space) => space.tile !== undefined && space.player === player && space.spaceType !== SpaceType_1.SpaceType.COLONY).length;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class MarsFirstPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_DEFAULT_POLICY;
        this.description = 'When you place a tile ON MARS, gain 1 steel';
    }
    onTilePlaced(player, space) {
        if (space.tile && space.spaceType !== SpaceType_1.SpaceType.COLONY && player.game.phase === Phase_1.Phase.ACTION) {
            player.addResource(Resources_1.Resources.STEEL, 1);
        }
    }
}
class MarsFirstPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_2;
        this.description = 'When you play a Building tag, gain 2 M€';
        this.isDefault = false;
    }
    onCardPlayed(player, card) {
        if (card.tags.includes(Tags_1.Tags.BUILDING))
            player.addResource(Resources_1.Resources.MEGACREDITS, 2);
    }
}
class MarsFirstPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_3;
        this.description = 'Your steel resources are worth 1 M€ extra';
        this.isDefault = false;
    }
}
class MarsFirstPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_4;
        this.description = 'Spend 4 M€ to draw a Building card';
        this.isDefault = false;
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canAfford(4) && player.canUseTripleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const game = player.game;
        game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new MarsFirstPolicy4Action_1.MarsFirstPolicy4Action()));
        MarsCoalition_1.MarsCoalition.handleTripleUsePolicyLogic(player, isDominantPartyAction);
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 4, {
            title: 'Select how to pay for Turmoil Mars First action',
            afterPay: () => {
                player.drawCard(1, { tag: Tags_1.Tags.BUILDING });
            },
        }));
        return undefined;
    }
}
exports.MARS_FIRST_BONUS_1 = new MarsFirstBonus01();
exports.MARS_FIRST_BONUS_2 = new MarsFirstBonus02();
exports.MARS_FIRST_DEFAULT_POLICY = new MarsFirstPolicy01();
exports.MARS_FIRST_POLICY_2 = new MarsFirstPolicy02();
exports.MARS_FIRST_POLICY_3 = new MarsFirstPolicy03();
exports.MARS_FIRST_POLICY_4 = new MarsFirstPolicy04();
//# sourceMappingURL=MarsFirst.js.map